import { render, staticRenderFns } from "./StartGame.vue?vue&type=template&id=6d529f07&scoped=true"
import script from "./StartGame.vue?vue&type=script&lang=js"
export * from "./StartGame.vue?vue&type=script&lang=js"
import style0 from "./StartGame.vue?vue&type=style&index=0&id=6d529f07&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d529f07",
  null
  
)

export default component.exports